import { render, staticRenderFns } from "./showConvocationForm.vue?vue&type=template&id=469962ae"
import script from "./showConvocationForm.vue?vue&type=script&lang=js"
export * from "./showConvocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports